import { render, staticRenderFns } from "./SanctionReportData.vue?vue&type=template&id=6e648ebc"
import script from "./SanctionReportData.vue?vue&type=script&lang=js"
export * from "./SanctionReportData.vue?vue&type=script&lang=js"
import style0 from "./SanctionReportData.vue?vue&type=style&index=0&id=6e648ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports